export default __webpack_public_path__ + "static/media/3.19c506b6.jpg";